import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { PresetState } from './preset.reducer';
import { Preset, PresetSettings, PresetsQueryParams } from '../../../core/api/preset/preset.types';
import { ReportRequest, SortingOrder } from '../reports/reports.types';

interface DeleteParamsWithExtra {
  id: Preset['id'];
  extra: string;
}

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/preset');

export const fetchPresetList = actionCreator.async<PresetsQueryParams, PresetState>('FETCH_PRESET_LIST');
export const createPreset = actionCreator.async<{ data: ReportRequest; formName: FormName }, {}>('CREATE_PRESET');
// ToDo: check after BE change:
export const updatePreset = actionCreator.async<{ data: any; formName: FormName }, Preset>('[UPDATE_PRESET]');
export const deletePreset = actionCreator.async<{ data: DeleteParamsWithExtra; formName: FormName }, {}>(
  'DELETE_PRESET',
);
export const changeFeedingListPreset = actionCreator<{ data: PresetSettings }>('CHANGE_FEEDING_LIST_PRESET');
export const saveFeedingListPreset = actionCreator.async<{ data: PresetSettings; formName: FormName }, {}>(
  'SAVE_FEEDING_LIST_PRESET',
);
export const updateFeedingListPreset = actionCreator<Preset>('UPDATE_FEEDING_LIST_PRESET');
export const setSortableColumn = actionCreator<string>('SET_SORTABLE_COLUMN');
export const setSortingOrder = actionCreator<SortingOrder>('SET_SORTING_ORDER');
export const updateRefusalsPreset = actionCreator<any>('UPDATE_REFUSALS_PRESET');
export const saveAndApplyRefusalsPreset = actionCreator.async<{ formName: FormName }, {}>(
  'SAVE_AND_APPLY_REFUSALS_PRESET',
);
export const updateStockTransactionsPreset = actionCreator<Preset>('UPDATE_STOCK_TRANSACTIONS_PRESET');
export const saveAndApplyStockTransactionsPreset = actionCreator.async<{ formName: FormName }, Preset>(
  'SAVE_AND_APPLY_STOCK_TRANSACTIONS_PRESET',
);
